<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="employee_division"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="divisionForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Divisi Karyawan"
          addButton="Tambah Divisi"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Tambah Divisi Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Divisi</h3>
          </div>

          <b-form id="divisionForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="name" label="Nama Divisi">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.divisionForm.name.$model"
                      :state="!$v.divisionForm.name.$invalid"
                      required
                      placeholder="Nama Divisi"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama divisi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Deskripsi">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.divisionForm.description.$model"
                      :state="!$v.divisionForm.description.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.divisionForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee_division",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      employee_division: [],
      loading: true,
      loadingSubmitModal: false,
      fields: [
        {
          key: "name",
          label: "Nama Divisi",
          class: "width-250",
          sortable: true
        },
        { key: "description", label: "Deskripsi" },
        { key: "action", class: "width-50 text-center" }
      ],
      divisionForm: masterInterfaces.division,
      isEdit: false
    };
  },
  validations: {
    divisionForm: {
      name: { required },
      description: {}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getDivision();
    },
    getDivision: function() {
      this.axios
        .get("web/master/employee/division/all/")
        .then(response => {
          this.employee_division = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(e) {
      this.isEdit = true;
      this.resetForm();
      this.divisionForm = e;
    },
    resetForm: function() {
      for (var a in masterInterfaces.division) {
        masterInterfaces.division[a] = null;
      }
      this.divisionForm = masterInterfaces.division;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah divisi ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/master/employee/division/edit/", this.divisionForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Divisi Berhasil",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan divisi ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/master/employee/division/add/", this.divisionForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Divisi Berhasil",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Divisi Gagal",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Master Divisi Karyawan",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  